import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _732e9c28 = () => import('../pages/auth.vue' /* webpackChunkName: "pages/auth" */).then(m => m.default || m)
const _45cd2eaf = () => import('../pages/group.vue' /* webpackChunkName: "pages/group" */).then(m => m.default || m)
const _49235120 = () => import('../pages/sp/index.vue' /* webpackChunkName: "pages/sp/index" */).then(m => m.default || m)
const _985a824e = () => import('../pages/androidpage/_id.vue' /* webpackChunkName: "pages/androidpage/_id" */).then(m => m.default || m)
const _7bdec0ba = () => import('../pages/iospage/_id/index.vue' /* webpackChunkName: "pages/iospage/_id/index" */).then(m => m.default || m)
const _7321d5ad = () => import('../pages/joinchat/_id.vue' /* webpackChunkName: "pages/joinchat/_id" */).then(m => m.default || m)
const _0eaf2c3b = () => import('../pages/sp/_name/index.vue' /* webpackChunkName: "pages/sp/_name/index" */).then(m => m.default || m)
const _18a8f484 = () => import('../pages/iospage/_id/market.vue' /* webpackChunkName: "pages/iospage/_id/market" */).then(m => m.default || m)
const _6e0fff82 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)
const _c5880b2c = () => import('../pages/_id.vue' /* webpackChunkName: "pages/_id" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/auth",
			component: _732e9c28,
			name: "auth"
		},
		{
			path: "/group",
			component: _45cd2eaf,
			name: "group"
		},
		{
			path: "/sp",
			component: _49235120,
			name: "sp"
		},
		{
			path: "/androidpage/:id?",
			component: _985a824e,
			name: "androidpage-id"
		},
		{
			path: "/iospage/:id?",
			component: _7bdec0ba,
			name: "iospage-id"
		},
		{
			path: "/joinchat/:id?",
			component: _7321d5ad,
			name: "joinchat-id"
		},
		{
			path: "/sp/:name",
			component: _0eaf2c3b,
			name: "sp-name"
		},
		{
			path: "/iospage/:id?/market",
			component: _18a8f484,
			name: "iospage-id-market"
		},
		{
			path: "/",
			component: _6e0fff82,
			name: "index"
		},
		{
			path: "/:id",
			component: _c5880b2c,
			name: "id"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js